import Banner from "../Banner/Banner";
import styles from "./Content.module.css";
import ContentItem from "./ContentItem/ContentItem";
import Slider from "../Slider/Slider";
import { useTranslation } from "react-i18next";

const Content = ({ contents = [] }) => {
  const { i18n } = useTranslation();

  const items =
    contents &&
    contents.map((content, contentIndex) => {
      if (content.title !== "header" && content.title !== "popup")
        return (
          <ContentItem
            title={i18n.dir() === "rtl" ? content.translation : content.title}
            key={`${content.title}-${content.priority}-${content.productSliders.map((p) => p.id).join(",")}`}            order={content.priority ? content.priority : undefined}
            internal_link={content.titleInternalLink}
            external_link={content.titleExternalLink}
          >
            {content.banners.map((banner) => {
              return <Banner data={banner} key={banner.id} />;
            })}
            {content?.productSliders && (
              <Slider
                data={content?.productSliders}
                key={content.productSliders.map((p) => p.id).join(",")}
              />
            )}
          </ContentItem>
        );
    });

  return <div className={styles.MainPage}>{items}</div>;
};

export default Content;
